export default __webpack_public_path__ + "static/media/hht1_ani_03.3505266f.png";